// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__14LGv","checkmark":"Checkbox_checkmark__1Ot2J"};